import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #262626;
  padding-top: 40px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 450px;
  border-radius: 5px;
  background-color: ${(props) => props.theme.colors.card};
  padding: 40px 30px;
  box-shadow: 0 2px 2.62px rgba(0, 0, 0, 0.23);
  gap: 15px;
`;

export const Login = styled.button`
  text-align: center;
  width: 450px;
  padding: 15px;
  border-radius: 6px;
  background-color: ${(props) => props.theme.colors.card};
  color: ${(props) => props.theme.colors.text};
  border: none;
  cursor: pointer;
`;

export const LinkText = styled.span`
  color: rgb(0, 149, 246);
  color: ${(props) => props.theme.colors.info};
  font-weight: bold;
`;
